<template>
    <div>
        <c_table :users_list="GetUsers"></c_table>
    </div>
</template>

<script>
import c_table from '@/components/c_table.vue';
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';


    export default {
        components: { c_table },
        data() {
            return{
        }},
        methods: {
        ...mapMutations({
        
        }),
        ...mapActions({
            fetchUsers: 'fetchUsers',
        }),
        ...mapGetters({
            
        }),
    },
    mounted() {
        this.fetchUsers()
        },
     computed: {
        ...mapState({
            users: state => state.users,
        }),
        ...mapGetters({
            GetUsers: "GetUsers",
        })
     },
        
    }
</script>

<style scoped>

</style>